import React from "react";
import PropTypes from "prop-types";
import { Table } from "components";
import {
    stringComparator,
    dateComparator,
    numberComparator
} from "utilities/table";
import { OrderedMap, List, Map } from "immutable";
import { STATE_STATUS } from "../../../constants";
import DecisioningDashboardService from "../services";
import { message } from "antd";
export default class DecisionDashboardTable extends React.Component{
    state = {
        count: 0,
        currentPage: "1",
        shouldFetch: false,
        status: STATE_STATUS.UNFETCHED
    };
    pageSize = 20;
    filters = {};
    filterObj = {};
    tableColumns = new Map({});
    checkedColumns = List([]);

    componentDidMount() {
        this.updateColumns({});
    }

    componentDidUpdate(prevProps) {
        this.updateColumns(prevProps);
    }

    onPageChange = (page, pageSize) => {
        this.props.fetchData(page, pageSize, this.filterObj);
    }

    onPageSizeChange = (page, pageSize) => {
        this.props.fetchData(page, pageSize, this.filterObj);
    };

    getActionNames = () => {
        let actions = [];
        if(this.props.permissions.get("proceed_decisioning_dashboard")){
            actions.push("Proceed");
        }
        if(this.props.permissions.get("refer_back_decisioning_dashboard")){
            actions.push("Refer Back");
        }
        if(this.props.permissions.get("sanction_decisioning_dashboard")) {
            actions.push("Sanction");
        }
        return actions;
    }

    getBulkActions = () => {
        let actions = [];
        if(this.props.permissions.get("proceed_decisioning_dashboard")){
            actions.push(ids => this.bulkProceed(ids));
        }
        if(this.props.permissions.get("refer_back_decisioning_dashboard")){
            actions.push(ids => this.bulkReferBack(ids));
        }
        if(this.props.permissions.get("sanction_decisioning_dashboard")) {
            actions.push(ids => this.bulkSanction(ids));
        }
        return actions;
    } 

    getCaseLevelData = (ids, isSanction) => {
        let idsArray =  ids.size ? ids.toJS() : ids;
        const filteredCases = this.props.rows.filter(_ => idsArray.includes(_["Case Id"]));
        const caseTaskIds = filteredCases && filteredCases.map(_ => (_["Task Id"])).toJS();
        const stage_id = filteredCases && filteredCases.toJS() && filteredCases.toJS()[0] && filteredCases.toJS()[0]["Stage Id"];
        const stage_name = filteredCases && filteredCases.toJS() && filteredCases.toJS()[0] && filteredCases.toJS()[0]["Stage"];
        const sanctionArray = filteredCases && filteredCases.toJS() && filteredCases.toJS().map(_ => ({
            initial_loaded_limit: 0,
            sanction_limit: _["LOS Proposed Limit"],
            case_id: _["Case Id"].replace("PGCP-", "")
        }));
        if(isSanction){
            return {
                sanctionArray,
                idsArray,
                caseTaskIds,
                stage_id,
                stage_name
            };
        } else {
            return {
                idsArray,
                caseTaskIds,
                stage_id,
                stage_name
            };
        }
    }

    getActionModal = (action, ids, case_task_ids, stageName, stage_id, sanction_array) => {
        this.setState({
            disableActionButton: true
        });
        const filterValues = new Map(this.filters);
        filterValues.map((_, k) => {
            if(k === "search") {
                this.filterObj[k] = _ && _[0];
            } else if(_ && typeof _[0] === "string") {
                // let key = `${k}__icontains`;
                let key = `${k}`;
                this.filterObj[key] = _[0];
            }else if(_ && typeof _[0] === "object") {
                if(_[0].min && _[0].min._isAMomentObject) {
                    this.filterObj[`${k}`] = `${_[0].min.format("YYYY-MM-DD")}, ${_[0].max.format("YYYY-MM-DD")}`;
                } else {
                    this.filterObj[`${k}`] = `${_[0].min},${_[0].max}`;
                }
            }
        }),
        this.props.history.replace(this.props.location.pathname, {
            ...this.props.location.state,
            case_actions: {
                page: this.props.currentPage,
                pageSize: this.pageSize,
                filters: this.filterObj,
                case_ids: ids.map(_ => _.replace("PGCP-", "")),
                case_id: ids[0].replace("PGCP-", ""),
                case_task_ids,
                stage_id,
                stage_name: stageName,
                current_stage: this.props.currentStage,
                action,
                params: this.props.location.pathname,
                sanction_array
            }
        });
    };

    bulkProceed = ids => {
        const {idsArray, caseTaskIds, stage_id, stage_name} = this.getCaseLevelData(ids, false);
        this.getActionModal("BULK_PROCEED", idsArray, caseTaskIds, stage_name, stage_id);
    }

    bulkReferBack = ids => {
        const {idsArray, caseTaskIds, stage_id, stage_name} = this.getCaseLevelData(ids, false);
        this.getActionModal("BULK_REFER", idsArray, caseTaskIds, stage_name, stage_id);
    }

    bulkSanction = ids => {
        const {sanctionArray, idsArray, caseTaskIds, stage_id, stage_name} = this.getCaseLevelData(ids, true);
        this.getActionModal("BULK_SANCTION", idsArray, caseTaskIds, stage_name, stage_id, sanctionArray);
    }

    onFilter = values => {
        this.filters = values;
        const filterValues = new Map(this.filters);
        this.filterObj = {};
        filterValues.map((_, k) => {
            if(k === "search") {
                this.filterObj[k] = _ && _[0];
            } else if(_ && typeof _[0] === "string") {
                // let key = `${k}__icontains`;
                let key = `${k}`;
                this.filterObj[key] = _[0];
            }else if(_ && typeof _[0] === "object") {
                if(_[0].min && _[0].min._isAMomentObject) {
                    this.filterObj[`${k}`] = `${_[0].min.format("YYYY-MM-DD") || ""}, ${_[0].max.format("YYYY-MM-DD") || ""}`;
                } else {
                    this.filterObj[`${k}`] = `${_[0].min || ""},${_[0].max || ""}`;
                }
            }
        });
        this.props.fetchData(1, this.pageSize, this.filterObj);
    }

    getColumnsLocalConfig() {
        let stageCheckedColumns = localStorage.getItem("decisiomnDashboardColumns");
        if(stageCheckedColumns) {
            stageCheckedColumns = JSON.parse(stageCheckedColumns);
        } else {
            stageCheckedColumns = {};
        }
        return stageCheckedColumns;
    }

    onColumnsUpdate = (columns) => {
        const columnsMap = columns.map(_ => _.toJS()).map(_ => ({ key: _.key, width: _.width })).toJS();
        let checkedColumns = this.getColumnsLocalConfig();
        checkedColumns = {...columnsMap };
        localStorage.setItem("decisiomnDashboardColumns", JSON.stringify(checkedColumns));
    }

    onExport = async () => {
        const {data} = await DecisioningDashboardService.bulkExport({...this.filterObj, stage_id: this.props.currentStage});
        var blob = new Blob([data], { type: "application/vnd.ms-excel" });
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = "decisioning-dashboard.xlsx";
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
        message.success("File Download Successfully");
    }

    bulkExport = async () => {
        const {data} = await DecisioningDashboardService.bulkExport({...this.filterObj, stage_id: this.props.stagePermissions.map(_ => _.id).toArray().join(",")});
        var blob = new Blob([data], { type: "application/vnd.ms-excel" });
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = "decisioning-dashboard.xlsx";
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
        message.success("File Download Successfully");
        // if(data) {
        //     message.info("Please check you email for the file");
        // } else {
        //     message.info("Error while exporting");
        // }
    }

    updateColumns() {
        const columnsLocalConfig = this.getColumnsLocalConfig();
        if(this.tableColumns.size === 0) {
            this.tableColumns = this.props.columns;
            const columnsMap =  columnsLocalConfig;
            const existingColsList = this.tableColumns;
            if(columnsMap) {
                this.checkedColumns = existingColsList.filter((_) => columnsMap[_.dataIndex]);
            }
            this.forceUpdate();
        }
    }

    getCutomButtons = () => {
        let buttonsTexts = ["Export"];
        // if(this.props.user.getIn(["groups"]) && this.props.user.getIn(["groups"]).find(_ => _.id === 29)){
        if(this.props.user.getIn(["groups"]) && this.props.user.getIn(["groups"]).find(_ => _.id === 31)){
            buttonsTexts.push("Bulk Export");
        }
        return buttonsTexts;
    }

    render() {
        const { rows, loading } = this.props;
        const columnsWithSorter = (this.tableColumns || new OrderedMap({})).map(_ => {
            let col = _;
            if(col.dataType === 1 || col.dataType === 2) {
                col.sorter = (a,b) => numberComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 3) {
                col.sorter = (a,b) => stringComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 4 || col.dataType === 5) {
                col.sorter = (a,b) => dateComparator(a.dataIndex, b.dataIndex);
            }

            if(col.dataType === 6) {
                col.sorter = (a,b) => numberComparator(a.dataIndex, b.dataIndex);
            }
            return col;
        });
        const data = this.props.rows || rows;
        return (
            <Table
                columns={columnsWithSorter}
                // checkedColumns={columnsWithSorter.map(_ => _.dataIndex).toList().toArray()}
                checkedColumns={this.checkedColumns.map(_ => _.dataIndex).toList().toArray()}
                filterColumns={columnsWithSorter.filter(_ => _.is_filter_applicable).map(_ => _.dataIndex).toList().toArray()}
                keyFilter={"Case Id"}
                data={(data && data || new List([])).map(_ => {
                    let row = _;
                    return row;
                })}
                bulkAction={this.getBulkActions()}
                loading={loading}
                bulkActionSelectedKey={"Case Id"}
                showTitle={true}
                className= {"padless-table inbox-table title-fix"}
                showFilters
                showXlsxBtn={false}
                showCustomButton
                customButtonTexts={this.getCutomButtons()}
                custonButtonIcons={["download", "download"]}
                onCustomButtonClicks={[this.onExport, this.bulkExport]}
                editable={true}
                expandIconAsCell={false}
                title={"Decisioning Dashboard"}
                onFilter={this.onFilter}
                bordered={true}
                bulkActionName={this.getActionNames()}
                showBulkActionBtn={true}
                noRowSelection={false}
                showFooter={false}
                fixedColsLeft={["Dealer"]}
                scrollY={true}
                // fixedColsRight={["expand"]}
                size={"small"}
                showColumnSelector={true}
                showPaginationOnly={true}
                showTotalPages={true}
                pagination={{
                    current: this.props.currentPage,
                    showSizeChanger: true,
                    defaultPageSize: 20,
                    pageSizeOptions: [
                        "20",
                        "50",
                        "100",
                        "500"
                    ],
                    position: "bottom",
                    total: this.props.totalEntries,
                    onChange: (page, pageSize) =>
                        this.onPageChange(page, pageSize),
                    onShowSizeChange: this.onPageSizeChange
                }}
                showTopSection={true}
                onColumnsUpdate={this.onColumnsUpdate}
                spanConfig={{
                    title: 4,
                    filters: 10,
                    btnSpan: 8,
                    btnOffset: 2
                }}
            />
        );
    }
}


DecisionDashboardTable.propTypes = {
    rows: PropTypes.object,
    expandable: PropTypes.bool,
    columns: PropTypes.object,
    loading: PropTypes.bool,
    reportName: PropTypes.string,
    reportId: PropTypes.number,
    childColumns: PropTypes.object,
    fetchVisibilityData: PropTypes.func,
    location: PropTypes.object,
    totalEntries: PropTypes.number,
    companyId: PropTypes.string,
    dateFilters: PropTypes.array,
    history: PropTypes.object,
    permissions: PropTypes.object,
    fetchData: PropTypes.func,
    currentPage: PropTypes.number,
    currentStage: PropTypes.number,
    user: PropTypes.object,
    stagePermissions: PropTypes.array
};